import { LitElement } from '@lit'

class NovaProductCrossSell extends LitElement {
  connectedCallback() {
    super.connectedCallback()

    document.addEventListener('nova:product:render-cross-sell', (event) => {
      this.updateContent(event.detail.html)
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    document.removeEventListener('nova:product:render-cross-sell', (event) => {
      this.updateContent(event.detail.html)
    })
  }

  updateContent(content) {
    if (!content) return
    // Clear existing children
    while (this.firstChild) {
      this.removeChild(this.firstChild)
    }
    // Append new children
    while (content.firstChild) {
      this.appendChild(content.firstChild)
    }
    this.requestUpdate()
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('nova-product-cross-sell', NovaProductCrossSell)
